import { smooth } from "./smooth";

export function qa() {
	const qaTrigger = document.querySelectorAll(".js-qaTrigger");
	const qaTriggerNode = Array.prototype.slice.call(qaTrigger, 0);

	qaTriggerNode.forEach((targetBox) => {
		targetBox.addEventListener("click", () => {
			if (targetBox.classList.contains("is-active")) {
				targetBox.classList.remove("is-active");
				targetBox.nextElementSibling.classList.remove("is-view");
			} else {
				targetBox.classList.add("is-active");
				targetBox.nextElementSibling.classList.add("is-view");
			}

			// アコーディオンで変動する高さを取得しないとsmoothのheight値が変更されない為に関数挿入
			smooth();
		});
	});
}
